export default
  "Civic Holiday": "Cottage life"
  "B.C. Day": "British Columbia"
